interface ImageDownloadMetaProps {
  url: string;
  filename: string;
}

export const handleImageDownload = async (files: ImageDownloadMetaProps[]) => {
  await Promise.all(
    files.map(async (file) => {
      const response = await fetch(file.url, {
        method: 'GET',
        cache: 'no-store',
      });
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = file.filename;
      link.click();
      window.URL.revokeObjectURL(url);
    })
  );
};
